import type { NotificationSeverity } from '@provider-portal/common/services/NotificationService';
import { ActionType, createAction } from 'typesafe-actions';

export type { NotificationSeverity };

export const showNotificationAction = createAction('@notifications/SHOW_NOTIFICATION')<{
  intlId: string;
  severity?: NotificationSeverity;
}>();

export const clearNotificationAction = createAction('@notifications/CLEAR_NOTIFICATION')();

export type NotificationsActions =
  | ActionType<typeof showNotificationAction>
  | ActionType<typeof clearNotificationAction>;
